import React, { useEffect } from 'react'
import { connect, useDispatch } from 'react-redux'
import { useHistory } from 'react-router-dom'
import { isEmpty } from 'lodash'
import { getAreaAds } from '../../redux/actions/area-ads'
import { Container, CustomImage } from './mixins'
import { randomizeArray } from '../../utils/random-util'
import { DataLayer } from '../../constants/gtm-events-listado-banner'

const getBanner = (areaAds, areaApplied) => {
  if (isEmpty(areaAds)) return null

  const bannersArea = areaAds.filter(a => a.area == areaApplied)
  // Si no se encuentran banners por area busca globales
  const banners = bannersArea.length > 0 ? bannersArea : areaAds.filter(a => !a.area)

  // Si hay varios de una misma prioridad los ordena al azar
  if (banners.length > 1) {
    randomizeArray(banners)
  }

  return banners[0]
}

const AreaAd = ({ areaAds, areaApplied }) => {
  const dispatch = useDispatch()
  const history = useHistory()
  const banner = getBanner(areaAds, areaApplied)

  const handleOnClick = () => {
    if (banner?.link) {
      DataLayer.handlerBannerClickTraking({ nombreBanner: banner?.key ?? 'banner-listado' })
      if (banner.external || banner.newTab) {
        window.open(banner.link, '_blank')
      } else {
        history.push(banner.link)
      }
    }
  }

  useEffect(() => {
    dispatch(getAreaAds())
  }, [])

  useEffect(() => {
    if (banner) {
      DataLayer.handlerBannerViewTraking({ nombreBanner: banner?.key ?? 'banner-listado' })
    }
  }, [banner])

  if (!banner) {
    return null
  }

  return (
    <Container showPointer={!!banner.link} onClick={handleOnClick}>
      <CustomImage id="area-ad-image" src={banner.image} />
    </Container>
  )
}

const states = ({ areaAdsStore }) => ({
  areaAds: areaAdsStore?.areaAds,
})

export default connect(states)(AreaAd)
